(function () {

  var drawer = document.getElementById('gba-cart-drawer');

  if (!drawer) return;


  var itemsContainer = drawer.querySelector('[data-gba-cart-items]');
  var emptyState = drawer.querySelector('[data-gba-cart-empty]');
  var footer = drawer.querySelector('[data-gba-cart-footer]');
  var countElements = document.querySelectorAll('[data-gba-cart-count]');
  var totalElement = drawer.querySelector('[data-gba-cart-total]');
  var checkoutTotal = drawer.querySelector('[data-gba-cart-checkout-total]');


  function formatMoney(cents, currency) {

    try {

      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-US',
        {
          style: 'currency',
          currency: currency || 'USD'
        }
      ).format(cents / 100);

    } catch (error) {

      return (cents / 100).toFixed(2);

    }

  }


  function openCart() {

    drawer.classList.add('is-open');

    drawer.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.style.overflow = 'hidden';

  }


  function closeCart() {

    drawer.classList.remove('is-open');

    drawer.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.style.overflow = '';

  }


  drawer
    .querySelectorAll('[data-gba-cart-close]')
    .forEach(function (button) {

      button.addEventListener(
        'click',
        closeCart
      );

    });


  document.addEventListener(
    'keydown',
    function (event) {

      if (event.key === 'Escape') {
        closeCart();
      }

    }
  );


  function loadCart(openAfterLoad) {

    fetch('/cart.js', {
      credentials: 'same-origin'
    })

      .then(function (response) {
        return response.json();
      })

      .then(function (cart) {

        renderCart(cart);

        if (openAfterLoad) {
          openCart();
        }

      });

  }


  function renderCart(cart) {

    var currency = cart.currency || drawer.getAttribute('data-currency') || 'USD';

    countElements =
      document.querySelectorAll('[data-gba-cart-count]');


    countElements.forEach(function (element) {
      element.textContent = cart.item_count;
    });


    if (totalElement) {
      totalElement.textContent =
        formatMoney(cart.total_price, currency);
    }


    if (checkoutTotal) {
      checkoutTotal.textContent =
        formatMoney(cart.total_price, currency);
    }


    if (cart.item_count === 0) {

      itemsContainer.innerHTML = '';

      emptyState.classList.add('is-visible');

      footer.style.display = 'none';

      return;

    }


    emptyState.classList.remove('is-visible');

    footer.style.display = 'block';


    itemsContainer.innerHTML =
      cart.items.map(function (item, index) {

        var image = '';

        if (item.featured_image && item.featured_image.url) {
          image = item.featured_image.url;
        }


        var variant = '';

        if (
          item.variant_title &&
          item.variant_title !== 'Default Title'
        ) {

          variant =
            '<div class="gba-cart__item-variant">' +
            escapeHtml(item.variant_title) +
            '</div>';

        }


        return (

          '<div class="gba-cart__item">' +

            '<div class="gba-cart__item-image">' +

              (
                image
                  ?
                  '<img src="' + image + '" alt="' +
                  escapeHtml(item.product_title) +
                  '">'
                  :
                  ''
              ) +

            '</div>' +


            '<div class="gba-cart__item-main">' +

              '<div class="gba-cart__item-top">' +

                '<div>' +

                  '<h3 class="gba-cart__item-title">' +
                    escapeHtml(item.product_title) +
                  '</h3>' +

                  variant +

                '</div>' +

                '<div class="gba-cart__item-price">' +
                  formatMoney(item.final_line_price, currency) +
                '</div>' +

              '</div>' +


              '<div class="gba-cart__item-actions">' +

                '<div class="gba-cart__quantity">' +

                  '<button type="button" data-cart-minus="' +
                    (index + 1) +
                    '">−</button>' +

                  '<span>' +
                    item.quantity +
                  '</span>' +

                  '<button type="button" data-cart-plus="' +
                    (index + 1) +
                    '">+</button>' +

                '</div>' +


                '<button type="button" class="gba-cart__remove" data-cart-remove="' +
                  (index + 1) +
                  '">' +
                  'Remove' +
                '</button>' +

              '</div>' +

            '</div>' +

          '</div>'

        );

      }).join('');


    bindItemControls();

  }


  function bindItemControls() {

    itemsContainer
      .querySelectorAll('[data-cart-minus]')
      .forEach(function (button) {

        button.addEventListener(
          'click',
          function () {

            var line =
              parseInt(
                button.getAttribute('data-cart-minus'),
                10
              );

            changeLine(line, -1);

          }
        );

      });


    itemsContainer
      .querySelectorAll('[data-cart-plus]')
      .forEach(function (button) {

        button.addEventListener(
          'click',
          function () {

            var line =
              parseInt(
                button.getAttribute('data-cart-plus'),
                10
              );

            changeLine(line, 1);

          }
        );

      });


    itemsContainer
      .querySelectorAll('[data-cart-remove]')
      .forEach(function (button) {

        button.addEventListener(
          'click',
          function () {

            var line =
              parseInt(
                button.getAttribute('data-cart-remove'),
                10
              );

            updateCartLine(line, 0);

          }
        );

      });

  }


  function changeLine(line, delta) {

    fetch('/cart.js')

      .then(function (response) {
        return response.json();
      })

      .then(function (cart) {

        var item = cart.items[line - 1];

        if (!item) return;


        var newQuantity =
          Math.max(
            0,
            item.quantity + delta
          );


        updateCartLine(
          line,
          newQuantity
        );

      });

  }


  function updateCartLine(line, quantity) {

    fetch('/cart/change.js', {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json'
      },

      body: JSON.stringify({
        line: line,
        quantity: quantity
      })

    })

      .then(function (response) {
        return response.json();
      })

      .then(function (cart) {
        renderCart(cart);
      });

  }


  function escapeHtml(text) {

    if (!text) return '';

    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  }


  /* ======================================================
     INTERCEPT ADD TO CART FORMS
  ====================================================== */

  document.addEventListener(
    'submit',
    function (event) {

      var form =
        event.target.closest(
          'form[action*="/cart/add"]'
        );


      if (!form) return;


      event.preventDefault();


      var formData =
        new FormData(form);


      fetch('/cart/add.js', {

        method: 'POST',

        body: formData,

        headers: {
          'Accept': 'application/json'
        }

      })

        .then(function (response) {

          if (!response.ok) {
            throw new Error('Unable to add product');
          }

          return response.json();

        })

        .then(function () {

          loadCart(true);

        })

        .catch(function () {

          form.submit();

        });

    }
  );


  /* ======================================================
     CART ICONS / LINKS
  ====================================================== */

  document.addEventListener(
    'click',
    function (event) {

      var cartLink =
        event.target.closest(
          'a[href="/cart"], a[href$="/cart"]'
        );


      if (!cartLink) return;


      event.preventDefault();

      loadCart(true);

    }
  );


  /* Initial cart state */

  loadCart(false);

})();